import { render } from "./VehicleDetailsView.vue?vue&type=template&id=6cfbcee8&scoped=true"
import script from "./VehicleDetailsView.vue?vue&type=script&lang=js"
export * from "./VehicleDetailsView.vue?vue&type=script&lang=js"

import "./VehicleDetailsView.vue?vue&type=style&index=0&id=6cfbcee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfbcee8"]])

export default __exports__